import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

import { NotificationService } from '../services/notification.service';

export const rolePermissionGuard = createAuthGuard<CanActivateFn>(async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData) => {
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  const grantedRoles = authData.grantedRoles.realmRoles;
  const routeRoles = route.data['rolePermission'];
  
  if (routeRoles.some((role: string) => grantedRoles.includes(role))) return true;

  notificationService.showToast('Non hai i permessi per accedere a questa sezione', { type: 'warning' });
  await router.navigate(['']);
  return false;
});
